import React, { useMemo } from 'react';
import { View, RefreshControl, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { countDriverTickets, countDriverResolvedTickets } from '../../../common/utils/ticketList/countDriverTickets';
import { DetailContainer } from '../../containers';
import { Dialog } from '../../components';
import { PrimaryButton, SecondaryButton, StatusBadge } from '../../design/components';
import PageHeading from '../../design/components/PageHeading';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { useUserContext } from '../../../common/utils/context';

import { useRefreshPage } from '../../hooks/useRefreshPage';
import TicketListView from './TicketListView';

const TicketListDetail = ({
	data: ticketList,
	machineName,
	refetch,
	trainingContext,
	serviceDocketId,
	onCreateTicket,
}) => {
	const navigation = useNavigation();
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);
	const styles = useThemedStyles(createStyles);
	const { tenantSettings } = useUserContext();

	const ticketCount = useMemo(() => countDriverTickets(ticketList.driverItems, tenantSettings), [tenantSettings, ticketList.driverItems]);
	const resolvedTicketCount = useMemo(() => countDriverResolvedTickets(ticketList.driverItems, tenantSettings), [tenantSettings, ticketList.driverItems]);

	const sortedTickets = ticketList.driverItems;
	// Resolved and Not resolved both count as actioned.
	const allTicketsActioned = ticketCount > 0 && resolvedTicketCount >= ticketCount;

	return (
		<>
			<ScrollView
				style={styles.scrollView}
				contentContainerStyle={styles.scrollContent}
				scrollIndicatorInsets={{ right: 1 }}
				refreshControl={(
					<RefreshControl
						refreshing={isRefreshing}
						onRefresh={refreshPage}
					/>
				)}
			>
				<PageHeading
					title="Tickets"
					subtitle={machineName}
					style={styles.heading}
					action={(
						<StatusBadge
							label={`${resolvedTicketCount} of ${ticketCount} resolved`}
							tone={allTicketsActioned ? 'success' : 'neutral'}
						/>
					)}
				/>
				{
					sortedTickets && (
						<TicketListView
							items={sortedTickets}
							showMachineName={false}
							onAfterResolve={refetch}
							trainingContext={trainingContext}
							serviceDocketId={serviceDocketId}
						/>
					)
				}
				{Boolean(onCreateTicket) && (
					<View style={styles.footer}>
						<SecondaryButton
							label="New ticket for this machine"
							icon="plus"
							onPress={onCreateTicket}
						/>
					</View>
				)}
				{allTicketsActioned && (
					<View style={styles.backFooter}>
						<PrimaryButton label="Back" onPress={() => navigation.goBack()} />
					</View>
				)}
			</ScrollView>

			<Dialog />
		</>
	);
};

const createStyles = ({ ui: { space } }) => ({
	scrollView: {
		flex: 1,
	},
	scrollContent: {
		paddingBottom: space.xl,
	},
	heading: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
	},
	footer: {
		paddingHorizontal: space.gutter,
	},
	backFooter: {
		paddingHorizontal: space.gutter,
		marginTop: space.md,
	},
});

export default DetailContainer(TicketListDetail);
